import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Navbar from '../components/Navbar';
import { toast } from 'sonner';
import { GoogleLogo, EnvelopeSimple, LockSimple, Eye, EyeSlash } from '@phosphor-icons/react';

export default function Login() {
  const { loginWithEmail } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await loginWithEmail(email, password, rememberMe);
      toast.success('Selamat datang kembali!');
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Gagal login');
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="max-w-md mx-auto px-4 py-12 md:py-16">
        <div className="border-2 border-foreground bg-white shadow-brutal-lg p-8" data-testid="login-card">
          <p className="text-xs uppercase tracking-[0.3em] font-bold mb-2">Masuk</p>
          <h1 className="font-display text-4xl font-bold tracking-tight mb-6" data-testid="login-title">
            Lanjut Berkarya.
          </h1>


          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-xs uppercase tracking-widest font-bold block mb-2">Email</label>
              <div className="relative">
                <EnvelopeSimple size={18} weight="bold" className="absolute left-3 top-1/2 -translate-y-1/2" />
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full border-2 border-foreground bg-white pl-10 pr-4 py-3 shadow-brutal-sm focus:outline-none focus:border-primary focus:shadow-none focus:translate-x-[2px] focus:translate-y-[2px] transition-all"
                  placeholder="kamu@email.com"
                  data-testid="login-email-input"
                />
              </div>
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest font-bold block mb-2">Password</label>
              <div className="relative">
                <LockSimple size={18} weight="bold" className="absolute left-3 top-1/2 -translate-y-1/2" />
                <input
                  type={showPassword ? "text" : "password"}
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full border-2 border-foreground bg-white pl-10 pr-12 py-3 shadow-brutal-sm focus:outline-none focus:border-primary focus:shadow-none focus:translate-x-[2px] focus:translate-y-[2px] transition-all"
                  placeholder="••••••••"
                  data-testid="login-password-input"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-foreground/50 hover:text-foreground transition-colors"
                >
                  {showPassword ? <EyeSlash size={20} weight="bold" /> : <Eye size={20} weight="bold" />}
                </button>
              </div>
            </div>

            <div className="flex items-center gap-2">
              <div className="relative flex items-center">
                <input
                  type="checkbox"
                  id="rememberMe"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  className="w-5 h-5 border-2 border-foreground bg-white checked:bg-primary appearance-none cursor-pointer relative shadow-[2px_2px_0px_0px_#09090B] checked:shadow-none checked:translate-x-[1px] checked:translate-y-[1px] transition-all"
                />
                {rememberMe && (
                  <span className="absolute left-1 top-1 text-white text-[10px] pointer-events-none font-black">✓</span>
                )}
              </div>
              <label htmlFor="rememberMe" className="text-xs font-bold uppercase tracking-wider cursor-pointer select-none hover:text-primary transition-colors">
                Ingatkan Saya
              </label>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full border-2 border-foreground bg-primary text-white px-4 py-3 font-bold uppercase tracking-wide shadow-brutal hover:shadow-brutal-sm hover:translate-x-[2px] hover:translate-y-[2px] active:shadow-none active:translate-x-[4px] active:translate-y-[4px] transition-all disabled:opacity-60"
              data-testid="login-submit-btn"
            >
              {loading ? 'Masuk...' : 'Masuk'}
            </button>
            <div className="text-center mt-2">
              <Link to="/forgot-password" size="sm" className="text-xs font-bold underline hover:text-primary transition-colors">
                Lupa kata sandi?
              </Link>
            </div>
          </form>

          <p className="mt-6 text-center text-sm">
            Belum punya akun?{' '}
            <Link to="/register" className="font-bold underline underline-offset-4" data-testid="login-register-link">
              Daftar Gratis
            </Link>
          </p>
        </div>
      </main>
    </div>
  );
}
